import React from 'react';
import { Link } from 'react-router-dom';
import FooterLogo from './../assets/img/footer-logo.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faFacebook, faYoutube, faInstagram,
    faLinkedin, faXTwitter, faTumblr,
    faPinterest, faReddit, faMediumM
} from '@fortawesome/free-brands-svg-icons';



const Footer = () => {
    return (
        <>
            <footer id="siteFooter">
                <div className="container">
                    <div className="footer-grid">
                        <div className="footer-brand">
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '4px' }}>
                                <img src={FooterLogo}
                                    alt="Figgers Law Logo"
                                    style={{ width: '132px', objectFit: 'contain', filter: 'brightness(0) invert(1)' }} />
                                <div id="footerLogoFallback" style={{ display: 'none', alignItems: 'center', gap: '10px' }}>
                                    <div className="logo-icon">NGF</div>
                                    <span className="font-display" style={{ fontSize: '22px', color: 'var(--ivory)' }}>Figgers Law</span>
                                </div>
                            </div>
                            <p>The Law Office of Natlie G. Figgers, PLLC, d/b/a Figgers Law. Business law, commercial litigation, and serious injury representation throughout Florida.</p>
                        </div>
                        <div className="footer-col">
                            <h4>Practice Areas</h4>
                            <ul>
                                <li><Link to="/personal-injury">Personal Injury</Link></li>
                                <li><Link to="/business-law">Business Law & Commercial Litigation</Link></li>
                            </ul>
                        </div>
                        <div className="footer-col">
                            <h4>Quick Links</h4>
                            <ul>
                                <li><Link to={'/about'}>About Us</Link></li>
                                <li><Link to='/#highlights'>Case Highlights</Link></li>
                                <li><Link to={'/#testimonials'}>Testimonials</Link></li>
                                <li><Link to='/#faqs'>FAQs</Link></li>
                                <li><Link to='/privacy-policy'>Privacy & Policy</Link></li>
                                <li><Link to='/terms-and-conditions'>Terms & Conditions</Link></li>
                                {/* <li><a onClick="showPage('calculator')">Settlement Calculator</a></li>
                                <li><a onClick="showPage('quick-assessment')">Quick Assessment</a></li> */}
                                <li><Link to={'/contact-us'}>Contact Us</Link></li>
                                {/* <li><a onClick="showPage('reviews')">Client Reviews</a></li>
                                <li><a onClick="showPage('documents')">Legal Documents</a></li> */}
                            </ul>
                        </div>
                        <div className="footer-col">
                            <h4>Contact</h4>
                            <ul className="footer-contact">
                                <li>
                                    <svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384" />
                                    </svg>
                                    <a href="tel:+8556435291" style={{ color: 'rgba(245,240,232,0.65)' }}>855-643-5291</a></li>
                                <li><svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                                    <path d="M7 3h8l3 3v4" />
                                    <rect x="3" y="9" width="18" height="8" rx="2" />
                                    <path d="M7 17v4h10v-4" />
                                    <path d="M8 13h2" />
                                    <path d="M12 13h4" />
                                </svg><span style={{ color: 'rgba(245,240,232,0.65)' }}>(954) 369-1771</span></li>

                                <li>
                                    <svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7" />
                                        <rect x="2" y="4" width="20" height="16" rx="2" />
                                    </svg>
                                    <a href="mailto:info@Figgerslaw.com">
                                        <span style={{ color: 'rgba(245,240,232,0.65)' }}>info@Figgerslaw.com</span>
                                    </a>
                                </li>
                                <li>
                                    <svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
                                        <circle cx="12" cy="10" r="3" />
                                    </svg>
                                    <span style={{ color: "rgba(245,240,232,0.65)" }}>
                                        10100 West Sample Road,<br />
                                        Suite 300,<br />
                                        Coral Springs,<br />
                                        FL 33065 (By appointments only)
                                    </span>
                                </li>
                            </ul>

                        </div>
                    </div>
                    <div className="footer-bottom">
                        <p style={{ marginTop: '8px' }}>© Copyright Figgers Law of The Law Office of Natlie G. Figgers, PLLC All rights reserved.</p>
                    </div>
                </div>
            </footer>
        </>

    );
};

export default Footer;